<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->

<!-- ============================================================== -->
<!-- Start Page Content here -->
<!-- ============================================================== -->
<div class="content-page bg-gray text-dark">
    <div class="content p-1">
        <h5 class="px-1 text-capitalize text-dark">{{words[language]['users']}}</h5>
        <div class="col-md-12 p-1">
            <div class="rounded">
                <div class="list-bar">
                    <form [formGroup]="form" class="form-row">
                        <div class="form-group col">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                                </div>
                                <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true" formControlName="inquiry" />
                            </div>
                        </div>
                    </form>
                    <div class="list-bar-actions">
                        <button [routerLink]="['/settings/permissions']" class="btn btn-secondary shadow" title="Permissions">
                            <span class="dripicons-lock h4"></span>
                        </button>
                        @if (security.permitted('users', 'user list', 'add')) {
                        <button class="btn btn-primary shadow" [disabled]="loading" title="Add" (click)="add()" data-target="#add-User-Modal" data-toggle="modal">
                            @if (!loading) {
                            <span class="dripicons-plus h4"></span>
                            }
                            @if (loading) {
                            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                            }
                        </button>
                        }
                    </div>
                </div>
                <div id="listing" class="col-md-12 tableFixHead" (scroll)="scrolled($event)">
                    @if (users) {
                    <table class="table table-sm table-hover table-striped table-responsive-sm" id="saleTable">
                        <thead>
                            <tr>
                                <th (click)="sort('name')" class="sorted" scope="col">
                                    {{ words[language]['name'] }}
                                    @if (sortedAsc('name')) {
                                    <span class="dripicons-chevron-up text-dark sort-icon"></span>
                                    }
                                    @if (sortedDesc('name')) {
                                    <span class="dripicons-chevron-down text-dark sort-icon"></span>
                                    }
                                </th>
                                <th scope="col">{{ words[language]['Email'] }}</th>
                                <th scope="col">Position</th>
                                <th scope="col" class="text-center">{{ words[language]['Status'] }}</th>
                                <th scope="col"><abbr title="Within three months">Recent</abbr> Login</th>
                                <th class="text-right" scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (user of users; track user) {
                            <tr class="clickable text-dark">
                                <td (click)="selectUser(user)" data-target="#edit-User-Modal" data-toggle="modal">{{user.name}}</td>
                                <td><a href="mailto:{{user.email}}">{{user.email}}</a></td>
                                <td>{{user.position}}</td>
                                <td (click)="selectUser(user)" class="text-center" data-target="#reactivate-User-Modal" data-toggle="modal">
                                    <h3 class="badge badge-{{status(user.status)}}">{{user.status}}</h3>
                                </td>
                                <td (click)="selectUser(user)">{{user.accessed | date:'medium'}}</td>
                                <!-- actions -->
                                <td class="text-right actions">
                                    <!-- delete -->
                                    @if ((user.status !== 'inactive') && security.permitted('users', 'user list', 'delete')) {
                                    <button title="Delete" class="btn btn-sm btn-link" (click)="selectUser(user)" data-target="#delete-User-Modal" data-toggle="modal">
                                        @if (!loading) {
                                        <span class="dripicons-trash text-danger"></span>
                                        }
                                        @if (loading) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"></span>
                                        }
                                    </button>
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                </div>
            </div>
            <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
                {{words[language]['displayed']}}</p>
        </div>
    </div>
</div>
<!-- ============================================================== -->
<!-- End Page content -->
<!-- ============================================================== -->

<!-- ============================================================== -->
<!-- modals -->
<!-- ============================================================== -->


<!-- alert modal -->
<div id="delete-User-Modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-body p-4">
                <div class="text-center">
                    <span class="dripicons-wrong h1 text-warning"></span>
                    <h4 class="mt-2">{{words[language].deactivateUser}}</h4>
                    <p class="mt-3">{{words[language].deactivateMessage}}</p>
                    <p class="mt-3">{{words[language].deactivateMessageSecure}}
                        <b>{{userSelected.email || ''}}</b>
                    </p>
                    <button type="button" class="btn btn-warning my-2" data-dismiss="modal" (click)="deactivateUser()">{{words[language].continue}}</button>
                    <button type="button" class="btn btn-secondary my-2 ml-2" data-dismiss="modal">{{words[language].cancel}}</button>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- alert modal activate-->
<div id="reactivate-User-Modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-body p-4">
                <div class="text-center">
                    <span class="mdi mdi-backup-restore h1 text-info"></span>
                    <h4 class="mt-2">{{words[language].activateUser}}</h4>
                    <p class="mt-3">{{words[language].activateUserSecure}}
                        <b>{{userSelected.email}}</b>
                    </p>
                    <button type="button" class="btn btn-info my-2" data-dismiss="modal" (click)="reactivateUser()">{{words[language].continue}}</button>
                    <button type="button" class="btn btn-secondary my-2 ml-2" data-dismiss="modal">{{words[language].cancel}}</button>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- update -->
<div id="edit-User-Modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-top modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="text-dark">{{words[language].updateResendInvitations}}</h4>
            </div>
            <div class="modal-body">
                <label class="text-dark">{{words[language].updateResendInvitationsMessage}}</label>
                <form [formGroup]="information">
                    <div class="form-group">
                        <div class="row text-dark">
                            <div class="col-md-3">
                                <label for="firstName_input">{{words[language].firstName}}</label>
                                <input type="text" class="form-control" id="firstName_input" [disabled]="loading || sending" placeholder="{{words[language].enterFirstName}}" formControlName="firstName">
                                <small id="firstNameHelp" class="form-text text-danger"></small>
                            </div>
                            <div class="col-md-3">
                                <label for="lastName_input">{{words[language].lastName}}</label>
                                <input type="text" class="form-control" id="lastName_input" [disabled]="loading || sending" placeholder="{{words[language].enterLastName}}" formControlName="lastName">
                                <small id="lastNameHelp" class="form-text text-danger"></small>
                            </div>
                            <div class="col-md-6">
                                <label for="email_input">{{words[language].emailAddress}}</label>
                                <input type="email" class="form-control" id="email_input" [disabled]="loading || sending" placeholder="{{words[language].enterEmailAddress}}" formControlName="email" (change)="urlLink = null">
                                <small id="emailHelp" class="form-text text-danger"></small>
                            </div>
                            <input value="copy_link" id="copy_link" class="position-fixed" style="z-index: -1;">
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                @if (!sending && (urlLink !== null)) {
                <button class="btn btn-info" (click)="copyInviteURL()">
                    <span class="dripicons-link"></span>
                    {{words[language].copyInviteURL}}</button>
                }
                @if (loading) {
                <button class="btn btn-info" disabled>
                    <div class="spinner-grow spinner-grow-sm text-light" role="status"></div>
                    {{words[language].copying}}
                </button>
                }
                <button type="button" class="btn btn-dark" [disabled]="information.invalid || sending" (click)="sendInvitation()">
                    @if (sending) {
                        <div class="spinner-grow spinner-grow-sm text-light" role="status"></div>
                    }
                    {{words[language].updateSendInvitation}}
                </button>
                <button type="button" class="btn btn-light" data-dismiss="modal" [disabled]="sending">{{words[language].close}}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!-- add -->
<div id="add-User-Modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-top modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="text-dark">Invite User</h4>
            </div>
            <div class="modal-body">
                <label class="text-dark">Invite a user to activate thier account and start using the system.</label>
                <form [formGroup]="information">
                    <div class="form-group">
                        <div class="row text-dark">
                            <div class="col-md-3">
                                <label for="firstName_input">{{words[language].firstName}}</label>
                                <input type="text" class="form-control" id="firstName_input" [disabled]="loading || sending" placeholder="{{words[language].enterFirstName}}" formControlName="firstName">
                                <small id="firstNameHelp" class="form-text text-danger"></small>
                            </div>
                            <div class="col-md-3">
                                <label for="lastName_input">{{words[language].lastName}}</label>
                                <input type="text" class="form-control" id="lastName_input" [disabled]="loading || sending" placeholder="{{words[language].enterLastName}}" formControlName="lastName">
                                <small id="lastNameHelp" class="form-text text-danger"></small>
                            </div>
                            <div class="col-md-6">
                                <label for="email_input">{{words[language].emailAddress}}</label>
                                <input type="email" class="form-control" id="email_input" [disabled]="loading || sending" placeholder="{{words[language].enterEmailAddress}}" formControlName="email" (change)="urlLink = null">
                                <small id="emailHelp" class="form-text text-danger"></small>
                            </div>
                            <input value="copy_link" id="copy_link" class="position-fixed" style="z-index: -1;">
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer d-flex justify-content-center">
                @if (!loading && urlLink !== null) {
                <button class="btn btn-info" (click)="copyInviteURL()">
                    <span class="dripicons-link"></span>
                    {{words[language].copyInviteURL}}</button>
                }
                @if (loading) {
                <button class="btn btn-info" disabled>
                    <div class="spinner-grow spinner-grow-sm text-light" role="status"></div>
                    {{words[language].copying}}
                </button>
                }
                <button type="button" class="btn btn-dark" [disabled]="sending" (click)="sendInvitation()">
                    @if (sending) {
                    <div class="spinner-grow spinner-grow-sm text-light" role="status"></div>
                    }
                    {{words[language].addInviteUser}}
                </button>
                <button type="button" class="btn btn-light" data-dismiss="modal" [disabled]="sending">{{words[language].close}}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
<!-- /.modal -->
